import InnerPageLayout from "../../components/feature/InnerPageLayout";

const sections = [
  {
    title: "제1조 (목적)",
    content: `이 약관은 주식회사 툴뮤직(이하 "회사")이 운영하는 ARTREPRENEUR 플랫폼(이하 "서비스")의 이용과 관련하여 회사와 이용자의 권리·의무 및 책임 사항을 규정함을 목적으로 합니다.`,
  },
  {
    title: "제2조 (정의)",
    content: `① "서비스"란 회사가 제공하는 크리에이터 IP 비즈니스화 플랫폼 및 관련 부가 서비스 일체를 의미합니다.\n② "이용자"란 이 약관에 동의하고 서비스를 이용하는 개인 또는 법인을 말합니다.\n③ "파트너 아티스트"란 아르트레너와 빌딩 계약을 체결한 창작자를 의미합니다.\n④ "수익 쉐어"란 아르트레너와 파트너 아티스트 간 약정된 수익 분배 비율에 따른 수익 배분을 의미합니다.`,
  },
  {
    title: "제3조 (약관의 효력 및 변경)",
    content: `① 이 약관은 서비스 화면에 게시하거나 기타 방법으로 이용자에게 공지함으로써 효력이 발생합니다.\n② 회사는 관련 법령에 위반되지 않는 범위에서 약관을 변경할 수 있으며, 변경 시 적용일자 및 변경 내용을 7일 전에 공지합니다.\n③ 이용자가 변경된 약관에 동의하지 않을 경우 서비스 이용을 중단하고 이용 계약을 해지할 수 있습니다.`,
  },
  {
    title: "제4조 (서비스의 제공)",
    content: `① 회사는 다음과 같은 서비스를 제공합니다.\n  1. 창작 IP 브랜딩 및 아이덴티티 설계\n  2. D2C 커머스 플랫폼 구축 및 운영\n  3. 마케팅 전략 수립 및 실행\n  4. 법무·회계 백오피스 지원\n  5. 투자 유치 및 IR 연계 지원\n② 서비스는 연중무휴 24시간 제공됨을 원칙으로 하되, 시스템 점검이나 불가항력적 사유 발생 시 일시 중단될 수 있습니다.`,
  },
  {
    title: "제5조 (수익 쉐어 및 정산)",
    content: `① 파트너 아티스트와 회사 간의 수익 쉐어 비율은 개별 빌딩 계약서에 명시된 조건에 따릅니다.\n② IT 인프라 운영에 필요한 필수 실비(서버, 도메인, PG 수수료 등 OPEX)는 회사의 마진 없이 실비 그대로 청구(Pass-through)됩니다.\n③ 수익 정산은 매월 말일 기준으로 익월 15일 이내에 지급됩니다.\n④ 목표 수익 달성 시 약정에 따라 수익 쉐어 비율이 단계적으로 인하될 수 있습니다.`,
  },
  {
    title: "제6조 (이용자의 의무)",
    content: `① 이용자는 다음 행위를 하여서는 안 됩니다.\n  1. 타인의 정보 도용 및 허위 정보 입력\n  2. 회사의 지식재산권 침해\n  3. 서비스의 정상적인 운영을 방해하는 행위\n  4. 제3자의 명예를 훼손하거나 개인정보를 침해하는 행위\n② 이용자는 관련 법령, 이 약관 및 회사의 공지 사항을 준수해야 합니다.`,
  },
  {
    title: "제7조 (개인정보 보호)",
    content: `회사는 이용자의 개인정보를 「개인정보 보호법」 등 관련 법령에 따라 보호합니다. 개인정보의 수집·이용·보관·파기에 관한 세부 사항은 별도의 개인정보처리방침에서 정합니다.`,
  },
  {
    title: "제8조 (면책 조항)",
    content: `① 회사는 천재지변, 전쟁, 기타 불가항력적 사유로 서비스를 제공할 수 없는 경우 책임이 면제됩니다.\n② 회사는 이용자의 귀책 사유로 인한 서비스 이용의 장애에 대해 책임을 지지 않습니다.\n③ 서비스를 통한 아티스트의 사업 성과는 회사가 보장하지 않으며, 시장 환경에 따라 달라질 수 있습니다.`,
  },
  {
    title: "제9조 (분쟁 해결)",
    content: `① 회사와 이용자 간 분쟁 발생 시 상호 협의를 통해 해결함을 원칙으로 합니다.\n② 협의가 이루어지지 않을 경우 대한민국 서울중앙지방법원을 관할 법원으로 합니다.\n③ 이 약관과 관련하여 적용되는 법률은 대한민국 법률로 합니다.`,
  },
  {
    title: "부칙",
    content: `이 약관은 2026년 3월 26일부터 시행합니다.\n최종 수정일: 2026년 3월 26일`,
  },
];

export default function TermsPage() {
  return (
    <InnerPageLayout>
      <section className="py-24 lg:py-36 px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="mb-12 lg:mb-16">
            <span className="inline-block text-xs font-display font-medium tracking-widest uppercase text-brand-purple mb-5 px-3 py-1 rounded-full border border-brand-purple/30 bg-brand-purple/5">
              Legal
            </span>
            <h1 className="font-display text-3xl md:text-5xl font-bold text-white leading-snug">이용약관</h1>
            <p className="mt-5 text-white/40 font-body text-sm leading-relaxed">시행일: 2026년 3월 26일 · 최종 수정: 2026년 3월 26일</p>
          </div>

          <div className="flex flex-col gap-10 lg:gap-14">
            {sections.map((sec) => (
              <div key={sec.title} className="glass rounded-2xl p-6 lg:p-9 flex flex-col gap-5">
                <h2 className="font-display text-lg font-bold text-white">{sec.title}</h2>
                <p className="text-white/60 text-sm font-body leading-loose whitespace-pre-line">{sec.content}</p>
              </div>
            ))}
          </div>

          <div className="mt-12 lg:mt-16 text-center">
            <p className="text-white/30 text-xs font-body">문의사항: <a href="mailto:eunhyun1@naver.com" className="text-brand-purple hover:text-brand-purple-bright cursor-pointer transition-colors">eunhyun1@naver.com</a></p>
          </div>
        </div>
      </section>
    </InnerPageLayout>
  );
}
